import { currentUser, clientId } from './utils.js';
import { get } from 'svelte/store';

const sb_auth_url = () => {
	return [true, 'true'].includes(process['env'].PROD_ENV)
		? 'https://auth.shopbox.ai'
		: 'https://beta-sb-auth-vlwut6qbsq-ew.a.run.app';
};

// export const fetchUsers = async () => {
// 	const res = await fetch(sb_auth_url() + `/api/v1/users?cid=${get(clientId)}`, {
// 		headers: { Authorization: `Bearer ${get(currentUser).accessToken}` }
// 	});
// 	return await res.json();
// };

// export const fetchCurrentUser = async () => {
// 	const res = await fetch(sb_auth_url() + `/api/v1/users/me?tokens=true&cid=${get(clientId)}`, {
// 		headers: { Authorization: `Bearer ${get(currentUser).accessToken}` }
// 	});
// 	return await res.json();
// };

export const fecthUserTokens = async () => {
	const res = await fetch(sb_auth_url() + `/api/v1/tokens?cid=${get(clientId)}`, {
		headers: { Authorization: `Bearer ${get(currentUser).accessToken}` }
	});
	return await res.json();
};

export const deleteToken = async (token_id) => {
	const res = await fetch(sb_auth_url() + `/api/v1/tokens/${token_id}?cid=${get(clientId)}`, {
		method: 'DELETE',
		headers: { Authorization: `Bearer ${get(currentUser).accessToken}` }
	});
	return res.ok && res.status == 204;
};

export const createToken = async (
	tokenName,
	website = '',
	apiScope = false,
	reportingScope = false
) => {
	let query_params = `?cid=${get(clientId)}`;
	if (website) {
		query_params += `&website=${website}`;
	}
	switch (true) {
		case apiScope && reportingScope:
			query_params += `&scopes=api,reporting`;
			break;
		case apiScope:
			query_params += `&scopes=api`;
			break;
		case reportingScope:
			query_params += `&scopes=reporting`;
			break;
		default:
			break;
	}
	const res = await fetch(sb_auth_url() + `/api/v1/tokens${query_params}`, {
		method: 'POST',
		body: JSON.stringify({ name: tokenName }),
		headers: {
			Authorization: `Bearer ${get(currentUser).accessToken}`,
			'Content-Type': 'application/json'
		}
	});
	return res.ok && res.status == 200;
};
